// FETCH ALL FABRIC PO
export const FETCH_FABRIC_PO_MASTER_REQUEST_DK = 'FETCH_FABRIC_PO_MASTER_REQUEST_DK';
export const FETCH_FABRIC_PO_MASTER_SUCCESS_DK = 'FETCH_FABRIC_PO_MASTER_SUCCESS_DK';
export const FETCH_FABRIC_PO_MASTER_FAILURE_DK = 'FETCH_FABRIC_PO_MASTER_FAILURE_DK';

// CREATE FABRIC PO
export const CREATE_FABRIC_PO_MASTER_REQUEST_DK = 'CREATE_FABRIC_PO_MASTER_REQUEST_DK';
export const CREATE_FABRIC_PO_MASTER_SUCCESS_DK = 'CREATE_FABRIC_PO_MASTER_SUCCESS_DK';
export const CREATE_FABRIC_PO_MASTER_FAILURE_DK = 'CREATE_FABRIC_PO_MASTER_FAILURE_DK';

// UPDATE FABRIC PO
export const UPDATE_FABRIC_PO_MASTER_REQUEST_DK = 'UPDATE_FABRIC_PO_MASTER_REQUEST_DK';
export const UPDATE_FABRIC_PO_MASTER_SUCCESS_DK = 'UPDATE_FABRIC_PO_MASTER_SUCCESS_DK';
export const UPDATE_FABRIC_PO_MASTER_FAILURE_DK = 'UPDATE_FABRIC_PO_MASTER_FAILURE_DK';

// FETCH SINGLE STATE OF FABRIC PO
export const FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST_DK = 'FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST_DK';
export const FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS_DK = 'FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS_DK';
export const FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE_DK = 'FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE_DK';

// DELETE FABRIC PO
export const DELETE_FABRIC_PO_MASTER_REQUEST_DK = 'DELETE_FABRIC_PO_MASTER_REQUEST_DK';
export const DELETE_FABRIC_PO_MASTER_SUCCESS_DK = 'DELETE_FABRIC_PO_MASTER_SUCCESS_DK';
export const DELETE_FABRIC_PO_MASTER_FAILURE_DK = 'DELETE_FABRIC_PO_MASTER_FAILURE_DK';

// FETCH PROPERTY
export const FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST_DK = 'FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST_DK';
export const FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS_DK = 'FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS_DK';
export const FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE_DK = 'FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE_DK';

export const RESET_FABRIC_PO_MASTER_INFO_DK = 'RESET_FABRIC_PO_MASTER_INFO_DK';

export const CREATE_FABRIC_PO_MASTER_FORM_DK = 'CREATE_FABRIC_PO_MASTER_FORM_DK';

export const UPDATE_FABRIC_PO_MASTER_FORM_DK = 'UPDATE_FABRIC_PO_MASTER_FORM_DK';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_FABRIC_PO_DETAILS_DK = 'NAVIGATE_FABRIC_PO_DETAILS_DK';

// NAVIGATE TO FABRIC PO COMPONENT
export const NAVIGATE_FABRIC_PO_MASTER_DK = 'NAVIGATE_FABRIC_PO_MASTER_DK';
export const FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK = 'FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK';
export const FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK = 'FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_FABRIC_PO_INVOICE_REQUEST_DK = 'FETCH_FABRIC_PO_INVOICE_REQUEST_DK';
export const FETCH_FABRIC_PO_INVOICE_SUCCESS_DK = 'FETCH_FABRIC_PO_INVOICE_SUCCESS_DK';
export const FETCH_FABRIC_PO_INVOICE_FAILURE_DK = 'FETCH_FABRIC_PO_INVOICE_FAILURE_DK';

export const RESET_FABRIC_PO_INVOICE_DK = 'RESET_FABRIC_PO_INVOICE_DK';

export const DELETE_BTN_UPDATE_API_REQUEST_DK = 'DELETE_BTN_UPDATE_API_REQUEST_DK';
export const DELETE_BTN_UPDATE_API_SUCCESS_DK = 'DELETE_BTN_UPDATE_API_SUCCESS_DK';
export const DELETE_BTN_UPDATE_API_FAILURE_DK = 'DELETE_BTN_UPDATE_API_FAILURE_DK';